import React from "react";
import Modal from "components/common/Modal/Modal";
import WarningIcon from "assets/images/warning.svg";
import { IUploadStatusInterface } from "./UploadStatusModal.interface";

const UploadStatusModal: React.FunctionComponent<IUploadStatusInterface> = (
  props: IUploadStatusInterface
) => {
  const {
    modalHeading,
    showModal,
    modalLoading,
    isSuccess,
    showProgressString,
    failedRecords,
    closeModalHandler,
    error,
  } = props;

  return (
    <Modal
      modalHeading={modalHeading}
      showModal={showModal}
      modalLoading={modalLoading}
      isSuccess={isSuccess}
      showProgressString={showProgressString ? false : true}
      failedRecords={failedRecords ? "" : ""}
      closeModalHandler={closeModalHandler}
    >
      {failedRecords ? (
        <div className="py-3">
          <section className="upload-error">
            <img src={WarningIcon} alt="failure" />
            <div className="title">Upload failed</div>
          </section>
          {failedRecords && (
            <div className="desc">
              {error &&
                (error! as any).errors.map((e: String[]) => {
                  return <div className="format-msg-style">{e}</div>;
                })}
                {/* {
                  error && (error! as any).message && <div className="format-msg-style">{ (error! as any).message }</div>
                } */}
            </div>
          )}
        </div>
      ) : null}
    </Modal>
  );
};

export default UploadStatusModal;
